import { Kuenstler, SingleKuenstler } from "@/types";
import { RichText } from "../StrapiComponents/RichText";
import { SingleKuenstlerComponent } from "../SingleKuenstler";
import styles from "@/styles/Kuenstler.module.scss";

export const KuenstlerComponent = ({ kuenstler }: { kuenstler: Kuenstler | null | undefined }) => {
	if (!kuenstler || typeof kuenstler === "undefined") {
		return null;
	}
	return (
		<section className="section-wrapper section-text-image orientation-Left">
			<div className="max-wrapper-content">
				<div className="flex">
					<div className={`content-wrapper`}>
						<h1>
							<span>{kuenstler.title}</span>
						</h1>
						<RichText content={kuenstler.description} className={styles.description} />
					</div>
				</div>
			</div>
			<div className="max-wrapper-content">
				<div className={`flex flex-gap ${styles.kuenstlerWrapper}`}>
					{kuenstler.single_kuenstler?.map((kuenstler: SingleKuenstler, index: number) => {
						return <SingleKuenstlerComponent kuenstler={kuenstler} key={index} />;
					})}
				</div>
			</div>
		</section>
	);
};
